import type { RouteRecordRaw } from 'vue-router';

import { TripPlannerPage } from '@apps/main/new-desktop/core/models/navigation';

import { buildRouteQuery } from './propsRouteBuilder/legacy/buildRouteQuery';
import type { PropsRouteBuilder } from './propsRouteBuilder/legacy/router';
import { Route } from './propsRouteBuilder/legacy/router';

export const BuildYourTripPageComponentAsyncImport: () => Promise<unknown> =
  () => import('../../new-desktop/pages/buildYourTrip/BuildYourTripPage.vue');

export const TripOverviewPageComponentAsyncImport: () => Promise<unknown> =
  () => import('../../new-desktop/pages/tripOverview/TripOverviewPage.vue');

export const TripOverviewPrintPageComponentAsyncImport: () => Promise<unknown> =
  () =>
    import('../../new-desktop/pages/tripOverview/TripOverviewPrintPage.vue');

export const FlightListPageComponentAsyncImport: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/flights/FlightsListsPage.vue');

export const FerryListPageComponentAsyncImport: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/ferry/FerryListPage.vue');

export const HotelSelectionPageComponentAsyncImport: () => Promise<unknown> =
  () => import('../../new-desktop/pages/hotelSelection/HotelSelectionPage.vue');

export const ActivitySelectionPageComponentAsyncImport: () => Promise<unknown> =
  () =>
    import('../../new-desktop/pages/activitySelection/ActivitySelectionPage.vue');

export const HotelDetailsPageComponentAsyncImport: () => Promise<unknown> =
  () => import('../../new-desktop/pages/hotelDetails/HotelDetailsPage.vue');

export const ActivityDetailsPageComponentAsyncImport: () => Promise<unknown> =
  () =>
    import('../../new-desktop/pages/activityDetails/ActivityDetailsPage.vue');

export const CarTripPageComponentAsyncImport: () => Promise<unknown> = () =>
  import('../../new-desktop/pages/carTrip/CarTripPage.vue');

const buildYourTripRoute: RouteRecordRaw = {
  name: TripPlannerPage.BuildYourTrip,
  path: '/travel/plan/build-your-trip',
  component: BuildYourTripPageComponentAsyncImport,
};

const tripOverviewRoute: RouteRecordRaw = {
  name: TripPlannerPage.TripOverview,
  path: '/travel/plan/overview',
  component: TripOverviewPageComponentAsyncImport,
  children: [
    {
      name: TripPlannerPage.HotelDetailsInTripOverview,
      path: ':ingredientIndex/hotel-details/:hotelCode',
      component: HotelDetailsPageComponentAsyncImport,
    },
    {
      name: TripPlannerPage.ActivityDetailsInTripOverview,
      path: ':ingredientIndex/activity-details/:activityCode',
      component: ActivityDetailsPageComponentAsyncImport,
    },
  ],
};

const tripOverviewPrintRoute: RouteRecordRaw = {
  name: TripPlannerPage.TripOverviewPrint,
  path: '/travel/plan/overview-print',
  component: TripOverviewPrintPageComponentAsyncImport,
};

const flightListRoute: RouteRecordRaw = {
  name: TripPlannerPage.FlightList,
  path: '/travel/plan/flights',
  component: FlightListPageComponentAsyncImport,
};

const ferryListRoute: RouteRecordRaw = {
  name: TripPlannerPage.FerryList,
  path: '/travel/plan/ferry',
  component: FerryListPageComponentAsyncImport,
};

const hotelSelectionRoute: RouteRecordRaw = {
  name: TripPlannerPage.HotelSelection,
  path: '/travel/plan/hotel-selection/:ingredientIndex',
  component: HotelSelectionPageComponentAsyncImport,
  children: [
    {
      name: TripPlannerPage.HotelDetailsInHotelSelection,
      path: 'hotel-details/:hotelCode',
      component: HotelDetailsPageComponentAsyncImport,
    },
  ],
};

const activitySelectionRoute: RouteRecordRaw = {
  name: TripPlannerPage.ActivitySelection,
  path: '/travel/plan/activity-selection/:ingredientIndex',
  component: ActivitySelectionPageComponentAsyncImport,
  children: [
    {
      name: TripPlannerPage.ActivityDetailsInActivitySelection,
      path: 'activity-details/:activityCode',
      component: ActivityDetailsPageComponentAsyncImport,
    },
  ],
};

const carTripRoute: RouteRecordRaw = {
  name: TripPlannerPage.CarTrip,
  path: '/travel/plan/car-trip',
  component: CarTripPageComponentAsyncImport,
};

const baseTripPlannerRoute: PropsRouteBuilder = Route()
  .withName(TripPlannerPage.BaseURL)
  .withPath('/travel/plan')
  .useComponent(() => import('../../components/TripPlannerRoot.vue'))
  .withChildren([
    buildYourTripRoute,
    tripOverviewRoute,
    tripOverviewPrintRoute,
    flightListRoute,
    ferryListRoute,
    hotelSelectionRoute,
    activitySelectionRoute,
    carTripRoute,
  ]);

export const TripPlannerRoute = buildRouteQuery(baseTripPlannerRoute).build();
